/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import _ from "lodash"
import angular from "angular"
import { canShowRoleMark, getRoleMark } from "common-library/role-mark"

angular
  .module("uCountitUiApp")

  .directive("roleMark", (Auth) => ({
    restrict: "A",

    //['role', 'type']
    scope: {
      roleMark: "=",
    },

    link(scope, element) {
      const setRoleMarkClass = function (role, type) {
        if (!role) {
          return
        }
        const mark = getRoleMark(role)
        if (!mark) {
          return
        }
        role = mark.id
        element[0].style.setProperty("--role-mark-color", mark.color)

        type = (type != null ? type.toLowerCase() : undefined) || "section"
        if (type === "ti") {
          type = "tableicon"
        }
        if (type === "sc") {
          type = "section"
        }

        element.addClass("role-mark")
        if (type === "section") {
          return element.append('<sup class="section ' + role + ' ">' + mark.symbol + "</sup>")
        } else if (type === "menu") {
          return element.append("<sup>" + mark.symbol + "</sup>")
        } else if (type === "ms") {
          element.addClass(role)
          return element.append("<sup>" + mark.symbol + "</sup>")
        } else {
          return element.addClass(role)
        }
      }

      scope.$watch("roleMark", function (value) {
        if (!_.isArray(value)) {
          return
        }

        return Auth.fetchCurrentAccount().then(function (account) {
          if (canShowRoleMark(account.role.group)) {
            return setRoleMarkClass(value[0], value[1])
          }
        })
      })
    },
  }))
